/**
 * Created by Mike Naughton on 2/16/18.
 */

import BrowserUtils from "core/utils/BrowserUtils";

export default BrowserUtils.detectMobile(window.navigator.userAgent);



//////////////////
// WEBPACK FOOTER
// ./public/js/core/is-mobile.js
// module id = 35
// module chunks = 1